import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { calculateAverageRating } from "../../Helpers/calculateAverageRating";
import { useTranslation } from "react-i18next";
import { MatchLocationToCurrency } from "../../main-component/Extensions/MatchLocationToCurrency";
import './Styles/CourseSection.css';
import '../hero/style/mobile-app-banner.css';
import GoogleTag from "../../Extensions/GoogleTag";

// Mobil uygulama banner bileşeni
const MobileAppBanner = () => {
  return (
    <div className="mobile-app-banner">
      <div className="mobile-app-content">
        <div className="mobile-app-text">
          <h3>LearningHell Mobil Uygulaması</h3>
          <p>Eğitimlerinize her an her yerden ulaşın. Hemen indirin!</p>
          <div className="mobile-app-links">
            <a 
              href="https://play.google.com/store/apps/details?id=com.fayik.LH&hl=en" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-store-link google-play"
              aria-label="Google Play'den indir"
            >
              <svg viewBox="0 0 24 24" className="store-icon">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              <span>Google Play'den İndir</span>
            </a>
           
          </div>
        </div>
        <div className="mobile-app-images">
          <div className="phone-image123 phone-image-11">
            <img src="/BannerPictures/Adsız tasarım (5).png" alt="LearningHell Mobil Uygulama Ekranı" />
          </div>
          <div className="phone-image123 phone-image-12">
            <img src="/BannerPictures/Adsız tasarım (6).png" alt="LearningHell Mobil Uygulama Ekranı" />
          </div>
        </div>
      </div>
    </div>
  );
};

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

// Course kartı bileşeni
const CourseCard = React.memo(({ course }) => {
  const rating = useMemo(() => calculateAverageRating(course.ratings), [course.ratings]);
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <>
      <Link
              onClick={ClickHandler}
              to={`/course-single/${course.courseId}`}
              aria-label={`View course: ${course.courseName}`}
            >
    <div className="wpo-popular-single" tabIndex="0" role="article">
      <div className="wpo-popular-item">
        <div className="wpo-popular-img">
          {!imageLoaded && <div className="skeleton-loading" style={{height: "200px"}} />}
          <img 
            src={course.courseImage} 
            alt={`${course.courseName} course cover`}
            onLoad={() => setImageLoaded(true)}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://via.placeholder.com/400x200?text=Course+Image';
            }}
            loading="lazy"
          />          <div 
            className={`thumb ${course.coursePrice === "0" || course.coursePrice === 0 ? 'free' : ''}`} 
            role="text" 
            style={{ display: imageLoaded ? 'block' : 'none' }}
            aria-label={`Course price: ${course.coursePrice === "0" ? "FREE" : `${MatchLocationToCurrency()}${course.coursePrice}`}`}
          >
            {course.coursePrice === "0" || course.coursePrice === 0 ? (
              "FREE"
            ) : (
              <span className="price">
                {MatchLocationToCurrency()}
                {course.coursePrice}
              </span>
            )}
          </div>
        </div>
        <div className="wpo-popular-content">
          <div className="wpo-popular-text-top">
            {/* <ul>
              <li>
                <img src={course.author} alt={`${course.authortitle} profile`} />
              </li>
              <li>
                <Link
                  onClick={ClickHandler}
                  to={`/course-single/${course.courseId}`}
                  aria-label={`View instructor ${course.authortitle}'s profile`}
                >
                  {course.authortitle}
                </Link>
              </li>
            </ul> */}
            <ul className="rating-stars">
              <li>
                <i className="fi flaticon-star" aria-hidden="true"></i>
              </li>
              <li aria-label={`Course rating: ${rating} out of 5`}>({rating})</li>
            </ul>
          </div>
          <h2>
          
              {course.courseName}
          
          </h2>
          <div className="wpo-popular-text-bottom">
            <ul>
              <li>
                <i className="fi flaticon-reading-book" aria-hidden="true"></i>
                <span aria-label={`${course.student} enrolled students`}>
                  {course.student} Students
                </span>
              </li>
              <li>
                <i className="fi flaticon-agenda" aria-hidden="true"></i>
                <span aria-label={`${course.lesson} total lessons`}>
                  {course.lesson} Lessons
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    </Link>
    </>
  );
});

const CourseSection = (props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (props.popularCourses) {
      setIsLoading(false);
    }
  }, [props.popularCourses]);

  return (
    <>
      <GoogleTag/>
      <div className={`wpo-popular-area section-padding ${props.pClass}`}>
        <div className="container">
          <MobileAppBanner />
          <div className="wpo-section-title-s2">
            <h2>
              {t("Discover Your Favorite Courses")}
              <span>
                <i className="shape">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 206 53" fill="none">
                    <path d="M152.182 2.58319C107.878 0.889793 54.8748 6.13932 21.2281 18.6943C14.2699 21.4407 7.93951 24.7738 5.70192 28.7128C4.27488 31.2398 5.03121 33.954 7.69121 36.2925C14.8835 42.3911 31.9822 45.4011 46.8006 47.3115C78.3067 51.0179 113.672 51.7406 145.489 48.3204C167.194 46.0009 200.667 39.5923 199.399 28.5709C198.543 20.0621 180.437 14.5729 162.979 11.6178C138.219 7.469 111.131 6.00576 84.5743 5.86862C71.32 5.85789 58.0913 6.85723 45.6675 8.78436C33.512 10.7186 21.2709 13.4317 12.6602 17.5817C11.2246 18.2877 8.62449 17.4553 9.9973 16.6813C20.7486 11.2493 38.0215 7.73493 53.9558 5.76368C77.1194 2.90994 101.75 3.75426 125.339 5.14356C158.167 7.2615 207.554 13.5139 204.928 30.7413C203.629 36.0898 194.762 40.5057 184.681 43.5503C156.563 51.768 119.114 53.6844 85.6331 52.5265C65.1694 51.7477 44.4831 50.1855 25.9972 46.2442C11.4129 43.1186 -1.0337 37.8297 0.0679738 30.5063C2.14003 19.9035 31.4913 12.0006 52.6201 7.98775C71.2971 4.45904 91.3384 2.2302 111.674 1.24636C125.228 0.595237 138.962 0.539188 152.536 1.15931C153.475 1.20224 154.154 1.55523 154.051 1.94876C153.951 2.33872 153.115 2.62135 152.182 2.58319Z" />
                  </svg>
                </i>
              </span>
            </h2>
          </div>
          <div className="wpo-popular-wrap">
            {isLoading ? (
              <div className="row">
                {[1,2,3].map((_, index) => (
                  <div className="col col-lg-4 col-md-6 col-12" key={index}>
                    <div className="wpo-popular-single skeleton-loading" style={{height: "400px"}} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="row">
                {props.popularCourses?.map((course, index) => (
                  <div className="col col-lg-4 col-md-6 col-12" key={index}>
                    <CourseCard course={course} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(CourseSection);
